//#region IMPORTS
import { Combobox, Transition } from "@headlessui/react";
import { MainComboboxOption } from "./MainComboBoxOption";
import { Fragment, useState } from "react";
import { ChevronUpDownIcon } from "@heroicons/react/20/solid";
//#endregion

//#region INTERFACE
interface Props {
  onChange: (value: string) => void;
  disabled?: boolean;
  options: string[];
  value?: string;
}
//#endregion

export default function MainFieldArrayFormComboBox({
  onChange,
  disabled = false,
  options,
  value,
}: Props) {
  //#region SETUP
  const [query, setQuery] = useState(value || "");

  const filtered =
    query === ""
      ? options
      : options.filter((c) => c.toLowerCase().includes(query.toLowerCase()));
  //#endregion

  //#region LOGIC
  const onChangeHandler = (value: string) => {
    setQuery(value);
    onChange(value);
  };
  //#endregion

  //#region RENDER
  return (
    <Combobox
      as="div"
      className="grow"
      value={query}
      onChange={(value) => onChangeHandler(value)}
      disabled={disabled}
    >
      {({ open }) => (
        <div className="relative">
          <Combobox.Input
            className="block w-full rounded-md px-3 py-1.5 border border-gray-300 text-gray-900 bg-white focus:border-gray-500 focus:ring-0 focus:outline-none sm:text-sm sm:leading-6 placeholder:text-gray-400 disabled:cursor-not-allowed disabled:bg-gray-100"
            onChange={(e) => onChangeHandler(e.target.value)}
            displayValue={() => query}
          />

          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none hover:cursor-pointer disabled:cursor-not-allowed">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
          </Combobox.Button>

          {filtered.length > 0 ? (
            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Combobox.Options className="absolute z-50 mt-1 max-h-48 w-full overflow-auto rounded-lg bg-gray-100 p-2 text-sm shadow-md">
                {filtered.map((item, i) => (
                  <MainComboboxOption key={i} value={item} text={item} />
                ))}
              </Combobox.Options>
            </Transition>
          ) : null}
        </div>
      )}
    </Combobox>
  );
  //#endregion
}
